export default __webpack_public_path__ + "static/media/jcb.5c3dcdd3.png";